import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { User } from "../types/user.type";

export const createUserQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (buildingId: string): Promise<User[]> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/users`, {
      params: { path: { buildingId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    queries: createQueryKeys("user", {
      building: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
    }),
  };
};
